import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { Card, CardActionArea, CardContent, Chip, Grid, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

import DescriptionIcon from "@material-ui/icons/Description";
import YouTubeIcon from "@material-ui/icons/YouTube";
import OpenInNewIcon from "@material-ui/icons/OpenInNew";
import * as Admin from "../../../store/ducks/admin.duck";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(3),
  },
  card: {
    height: "100%",
    borderRadius: 12,
    transition: "all .25s ease",
    border: "1px solid #e0e0e0",

    "&:hover": {
      transform: "translateY(-4px)",
      boxShadow: theme.shadows[6],
    },
  },
  actionArea: {
    height: "100%",
  },
  content: {
    display: "flex",
    flexDirection: "column",
    height: 180,
  },
  icon: {
    fontSize: 42,
    marginBottom: theme.spacing(2),
  },
  title: {
    fontWeight: 600,
    flexGrow: 1,
  },
  footer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginTop: theme.spacing(2),
  },
  pdf: {
    color: "blue",
  },
  video: {
    color: "#ff0000",
  },
}));

export default function HowToArticles() {
  const classes = useStyles();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(Admin.actions.fetchHelpItems());
  }, [dispatch]);

  const helpItems = useSelector((state) => state.admin.HelpItems);

  return (
    <div className={classes.root}>
      <Typography variant="h4" gutterBottom>
        How To Articles
      </Typography>

      <Typography color="textSecondary" paragraph>
        Browse our collection of guides and tutorial videos.
      </Typography>

      <Grid container spacing={3}>
        {helpItems.map((item) => {
          const isPdf = item.pdf_url !== "";

          const url = isPdf ? `https://files.ruralhealthconnect.com.au/fileStoreRHC/${item.pdf_url}` : item.youtube_url;

          return (
            <Grid item xs={12} sm={6} md={4} key={item.title}>
              <Card className={classes.card}>
                <CardActionArea href={url} target="_blank" rel="noopener noreferrer" className={classes.actionArea}>
                  <CardContent className={classes.content}>
                    {isPdf ? <DescriptionIcon className={`${classes.icon} ${classes.pdf}`} /> : <YouTubeIcon className={`${classes.icon} ${classes.video}`} />}

                    <Typography variant="h6" className={classes.title} gutterBottom>
                      {item.title}
                    </Typography>

                    <div className={classes.footer}>
                      <Chip size="small" label={isPdf ? "PDF" : "Video"} color={isPdf ? "primary" : "secondary"} />

                      <OpenInNewIcon color="action" />
                    </div>
                  </CardContent>
                </CardActionArea>
              </Card>
            </Grid>
          );
        })}
      </Grid>
    </div>
  );
}
